import React, { useState, useMemo } from "react";
import SummarySection from "./SummarySection";
import SummaryCard from "./SummaryCard";
import { getAmountInCurrencyFormat, limitNumber } from "../../utils/number";

export default function BusinessValue({ netPosition }) {
  const [goldRate, setGoldRate] = useState("");
  const [silverRate, setSilverRate] = useState("");

  const hasRates = goldRate > 0 || silverRate > 0;

  const values = useMemo(() => {
    const gRate = Number(goldRate) || 0;
    const sRate = Number(silverRate) || 0;

    const goldValue = netPosition.gold * gRate;
    const silverValue = netPosition.silver * sRate;
    const cashValue = netPosition.cash || 0;

    return {
      goldValue,
      silverValue,
      cashValue,
      total: goldValue + silverValue + cashValue,
    };
  }, [netPosition, goldRate, silverRate]);

  return (
    <SummarySection>
      <SummaryCard
        icon="fa-solid fa-chart-line"
        title="Business Value"
        total={
          hasRates ? `PKR ${getAmountInCurrencyFormat(values.total)}` : "—"
        }
        items={[
          {
            label: "Gold",
            value: `${limitNumber(netPosition.gold)} g ${
              goldRate
                ? `× ${goldRate} = PKR ${getAmountInCurrencyFormat(
                    values.goldValue,
                  )}`
                : ""
            }`,
          },
          {
            label: "Silver",
            value: `${limitNumber(netPosition.silver)} g ${
              silverRate
                ? `× ${silverRate} = PKR ${getAmountInCurrencyFormat(
                    values.silverValue,
                  )}`
                : ""
            }`,
          },
          {
            label: "Cash",
            value: `PKR ${getAmountInCurrencyFormat(netPosition.cash || 0)}`,
          },
        ]}
      />

      {/* 🔥 Better Rate Input UI */}
      <div className="rate-card">
        <h4>Enter Current Market Rates</h4>

        <div className="rate-grid">
          <div className="rate-item">
            <label>Gold Rate (per gram)</label>
            <input
              type="number"
              placeholder="e.g. 20000"
              value={goldRate}
              onChange={(e) => setGoldRate(e.target.value)}
            />
          </div>

          <div className="rate-item">
            <label>Silver Rate (per gram)</label>
            <input
              type="number"
              placeholder="e.g. 250"
              value={silverRate}
              onChange={(e) => setSilverRate(e.target.value)}
            />
          </div>
        </div>

        {!hasRates && (
          <p className="rate-hint">
            ⚠ Enter current gold & silver rates to calculate business value
          </p>
        )}
      </div>
    </SummarySection>
  );
}
